import { MinusCircleOutlined } from '@ant-design/icons';
import { Button, Col, DatePicker, Form, Input, Modal, Radio, Row, Select, Table } from 'antd';
import { useFormik } from 'formik';
import moment from 'moment';
import React, { useEffect } from 'react';
import { one_way_columns, round_trip_columns } from './TripTables';
import * as yup from 'yup';
const Option = Select.Option

const flightValidation = yup.lazy((vals) => {
  return yup.object().shape({
    mode: yup.string().required("Flight mode is required."),
    time_preference: yup.string().required("Time Preference is required."),
    seat_preference: yup.string().required("Seat Preference is required."),
    meal_preference: yup.string().required("Meal Preference is required."),
    description: yup.string().required("Description is required."),
    trips: yup.array().of(yup.object().shape({
      departure_date: yup.string().required("Departure date is required."),
      from_city: yup.string().required("From city is required."),
      to_city: yup.string().required("To city is required."),
      return_date: yup.string().test("return_date", "Return date is required.", () => {
        if (vals.mode === "round_trip" && !vals.trips?.[0].return_date) {
          return false
        };
        return true
      })
    }))
  })
})
const FlightData = ({ tripForm, isModalVisible, setIsModalVisible }) => {
  const { flight_reservations = {} } = tripForm?.values;
  const flightFormik = useFormik({
    initialValues: {
      mode: "",
      time_preference: "",
      seat_preference: "",
      meal_preference: "",
      description: "",
      trips: [{
        departure_date: "",
        from_city: "",
        to_city: "",
        return_date: ""
      }]
    },
    // enableReinitialize: true,
    validationSchema: flightValidation,
    onSubmit: (vals) => {
      tripForm.setFieldValue("flight_reservations", vals)
      handleModalCancelButton()
    }
  })

  // useEffect(() => {
  //   if (isModalVisible)
  //     flightFormik.setValues({
  //       mode: "",
  //       time_preference: "",
  //       seat_preference: "",
  //       meal_preference: "",
  //       description: "",
  //       trips: [{
  //         departure_date: "",
  //         from_city: "",
  //         to_city: "",
  //         return_date: ""
  //       }],
  //       ...flight_reservations
  //     })
  //   // eslint-disable-next-line
  // }, [isModalVisible])

  useEffect(() => {
  if (isModalVisible) {
    let trips = flight_reservations?.trips?.length
      ? flight_reservations.trips
      : [{
          departure_date: "",
          from_city: "",
          to_city: "",
          return_date: ""
        }];
    
    flightFormik.setValues({
      mode: flight_reservations?.mode || "",
      time_preference: flight_reservations?.time_preference || "",
      seat_preference: flight_reservations?.seat_preference || "",
      meal_preference: flight_reservations?.meal_preference || "",
      description: flight_reservations?.description || "",
      trips: trips
    });
  }
}, [isModalVisible, flight_reservations]);

  const handleModalCancelButton = () => {
    setIsModalVisible(false);
    flightFormik.resetForm();
  }

  const onNewRowChange = (type, idx) => {
    if (type === "remove") {
      if (idx > -1) {
        let trips = flightFormik?.values?.trips
        trips.splice(idx, 1)
        flightFormik.setFieldValue("trips", trips)
      }
    } else {
      let trips = flightFormik?.values?.trips;
      trips = [...trips, {
        departure_date: "",
        from_city: "",
        to_city: "",
        return_date: ""
      }]
      flightFormik.setFieldValue("trips", trips)
    }
  }

  console.log(flightFormik.errors);
  const renderFlightForm = () => {
    return (
      <form name="flight-form" onSubmit={flightFormik.handleSubmit} className="modal-form">
        <Row>
          <Col span={8}>
            <Form.Item  label={<>Flight Mode<span className="required-star">*</span></>} >
              <Radio.Group
                name="mode"
                value={flightFormik.values?.mode}
                onChange={(e) => {
                  flightFormik.setFieldValue("mode", e.target.value)
                }}>
                <Radio value="one_way">One Way</Radio>
                <Radio value="round_trip">Round Trip</Radio>
                <Radio value="multi_city">Multi-City</Radio>
              </Radio.Group>
              {flightFormik.touched.mode && flightFormik.errors.mode && <div className='errorMsg'>
                {flightFormik.errors.mode}
              </div>}
            </Form.Item>
          </Col>
          <Col span={5}></Col>
          <Col span={5}>
            <Form.Item label={<>Seat Preference<span className="required-star">*</span></>} >
              <Select
                style={{ width: 200 }}
                placeholder="Seat Preference"
                name="seat_preference"
                value={flightFormik.values?.seat_preference}
                onChange={(val) => {
                  flightFormik.setFieldValue("seat_preference", val)
                }}
              >
                <Option key='45' value='Any'>None</Option>
                <Option key='46' value='Window'>Window</Option>
                <Option key='47' value='Middle'>Middle</Option>
                <Option key='48' value='Aisle'>Aisle</Option>
              </Select>
              {flightFormik.touched.seat_preference && flightFormik.errors.seat_preference && <div className='errorMsg'>
                {flightFormik.errors.seat_preference}
              </div>}
            </Form.Item>
          </Col>
          <Col span={5}>
            <Form.Item label={<>Meal Preference<span className="required-star">*</span></>}
            >
              <Select
                style={{ width: 200 }}
                placeholder="Meal Preference"
                name="meal_preference"
                value={flightFormik?.values?.meal_preference}
                onChange={(val) => {
                  flightFormik.setFieldValue("meal_preference", val)

                }}
              >
                <Option key='54' value='Vegetarian'>Veg</Option>
                <Option key='56' value='Non - Vegetarian'>Non Veg</Option>
              </Select>
              {flightFormik.touched.meal_preference && flightFormik.errors.meal_preference && <div className='errorMsg'>
                {flightFormik.errors.meal_preference}
              </div>}
            </Form.Item>
          </Col>
        </Row>
        <div className="trips-detail detail-card p1">
          {flightFormik.values?.trips?.map((item, index) =>
            <Row key={`flightrows_${index}`} className='mt2'>
              <Col span={4}>
                <Form.Item label={<>Depart From<span className="required-star">*</span></>}
                >
                  <Input placeholder="Enter"
                    value={flightFormik.values?.trips?.[index]?.from_city}
                    name={`fli_from_city_key${index}`}
                    onChange={(e) => {
                      let trips = flightFormik.values.trips;
                      trips[index].from_city = e.target.value
                      flightFormik.setFieldValue("trips", trips)
                    }}
                  />
                  {flightFormik.touched.trips?.[index]?.from_city && flightFormik.errors.trips?.[index]?.from_city && <div className='errorMsg'>
                    {flightFormik.errors.trips?.[index]?.from_city}
                  </div>}
                </Form.Item>
              </Col>
              <Col span={4} className="ml1">
                <Form.Item label={<>Arrive At<span className="required-star">*</span></>}>
                  <Input placeholder="Enter"
                    value={flightFormik.values?.trips?.[index]?.to_city}
                    name={`fli_to_city_key${index}`}
                    onChange={(e) => {
                      let trips = flightFormik.values.trips;
                      trips[index].to_city = e.target.value
                      flightFormik.setFieldValue("trips", trips)
                    }} />
                  {flightFormik.touched.trips?.[index]?.to_city && flightFormik.errors.trips?.[index]?.to_city && <div className='errorMsg'>
                    {flightFormik.errors.trips?.[index]?.to_city}
                  </div>}
                </Form.Item>
              </Col>
              <Col span={4} className="ml1">
                <Form.Item label={<>Departure Date<span className="required-star">*</span></>}>
                  <DatePicker format={'DD/MM/YYYY hh:mm:ss a'}
                    showTime
                    value={
                      flightFormik.values?.trips?.[index]?.departure_date ?
                        moment(flightFormik.values?.trips?.[index]?.departure_date, 'DD/MM/YYYY hh:mm:ss a') :
                        undefined}
                    onChange={(date) => {
                      let trips = flightFormik.values.trips;
                      trips[index].departure_date = date ? moment(date).format('DD/MM/YYYY hh:mm:ss a') : ""
                      trips[index].return_date = ""
                      flightFormik.setFieldValue("trips", trips)
                    }}
                    name={`fli_departure_date_key${index}`}
                  />
                  {flightFormik.touched.trips?.[index]?.departure_date && flightFormik.errors.trips?.[index]?.departure_date && <div className='errorMsg'>
                    {flightFormik.errors.trips?.[index]?.departure_date}
                  </div>}
                </Form.Item>
              </Col>
              {flightFormik.values?.mode === 'round_trip' ?
                <Col span={4} className="ml1">
                  <Form.Item label={<>Return Date<span className="required-star">*</span></>}
                  >
                    <DatePicker format={'DD/MM/YYYY HH:mm:ss a'} showTime
                      name={`fli_return_date_key${index}`}
                       showNow={
                         !moment(
                           flightFormik.values?.trips?.[index]?.departure_date,
                           "DD/MM/YYYY HH:mm:ss a"
                         ).isAfter(moment()) // 🔑 hide Now if departure is in the future
                       }
                      value={
                        flightFormik.values?.trips?.[index]?.return_date ?
                          moment(flightFormik.values?.trips?.[index]?.return_date, 'DD/MM/YYYY HH:mm:ss a') :
                          undefined}
                      onChange={(date) => {
                        let trips = flightFormik.values.trips;
                        trips[index].return_date = date ? moment(date).format('DD/MM/YYYY HH:mm:ss a') : ""
                        flightFormik.setFieldValue("trips", trips)
                      }}
                      disabledDate={(current) => {
                        let customDate = moment(flightFormik.values?.trips?.[index]?.departure_date, "DD/MM/YYYY HH:mm:ss a");
                        return current && current < moment(customDate);
                      }}
                    />
                    {flightFormik.touched.trips?.[index]?.return_date && flightFormik.errors.trips?.[index]?.return_date && <div className='errorMsg'>
                      {flightFormik.errors.trips?.[index]?.return_date}
                    </div>}
                  </Form.Item>
                </Col> : null}
              <Col span={1}>
                {index >= 1 ?
                  <MinusCircleOutlined className='mt3' onClick={() => onNewRowChange('remove', index)} /> : null}
              </Col>
            </Row>
          )}
          {flightFormik.values?.mode === 'multi_city' && flightFormik.values?.trips?.length <= 5 ? <>
            <hr />
            <div className='p1 cursor' onClick={() => onNewRowChange('add')}> + Add another line</div>
          </>
            : null}
        </div>
        <div className='p1'>
          <Row className='mt1'>
            <Col span={6}>
              <Form.Item label={<>Time Preferences<span className="required-star">*</span></>}
              >
                <Select
                  style={{ width: 200 }}
                  placeholder="Select"
                  name="time_preference"
                  value={flightFormik.values?.time_preference}
                  onChange={(val) => {
                    flightFormik.setFieldValue("time_preference", val)
                  }}
                >
                  <Option key='64e' value='Morning (Before 11 AM)'>Morning (Before 11 AM)</Option>
                  <Option key='66e' value='Afternoon (11 AM - 5 PM)'>Afternoon (11 AM - 5 PM)</Option>
                  <Option key='67e' value='Evening (5 PM - 9 PM)'>Evening (5 PM - 9 PM)</Option>
                  <Option key='68e' value='Night (After 9 PM)'>Night (After 9 PM)</Option>
                </Select>
                {flightFormik.touched.time_preference && flightFormik.errors.time_preference && <div className='errorMsg'>
                  {flightFormik.errors.time_preference}
                </div>}
              </Form.Item>

            </Col>
            <Col span={6} className="ml1">
              <Form.Item label={<>Description<span className="required-star">*</span></>}
              >
                <Input.TextArea
                  placeholder="Enter Description"
                  autoSize={{ minRows: 1, maxRows: 5 }}
                  maxLength={250}
                  name={`description`}
                  value={flightFormik.values?.trips?.description}
                  onChange={(e) => {
                    let description = e.target.value
                    flightFormik.setFieldValue("description", description)
                  }}
                />
                {flightFormik.touched?.description && flightFormik.errors?.description && <div className='errorMsg'>
                  {flightFormik.errors?.description}
                </div>}
              </Form.Item>
            </Col>
          </Row>
        </div>
        <div className='mb3'>
          <Button key="2" className="cancelButton ml1 mt3 floatRight" onClick={() => handleModalCancelButton()}>Cancel</Button>
          <Button key="1" htmlType="submit" className="formButton mt3 primaryButton floatRight"
          >Save</Button>
        </div>
      </form>
    )
  };
  return (
    <>
      <div className="trips-detail detail-card mb2">
        <Modal
          title={"Add Flight Details"}
          visible={isModalVisible}
          onCancel={() => {
            setIsModalVisible(false)
          }}
          footer={[]}
          className="center-aligned-modal-big"
        >
          {renderFlightForm()}
        </Modal>
        <div className='mt1'>
          <Button
            className="primary-btn floatRight mr1"
            onClick={() => {
              setIsModalVisible(true);
            }}
          >
            {(flight_reservations?.trips?.length && flight_reservations?.trips?.length && flight_reservations?.trips[0]?.from_city)
              ? 'Edit' : 'Add Flight Details'}
          </Button>
        </div>
        <div className='pl1'>
          Flight Type: <b className='capitalize'>
            {flight_reservations?.mode?.replace(/_/g, " ") || 'No Data'}
          </b> &nbsp;| &nbsp;
          Meal Preference: <b className='capitalize'>
            {flight_reservations?.meal_preference?.replace(/_/g, " ") || 'No Data'}
          </b> &nbsp;| &nbsp;
          Seat Preference: <b className='capitalize'>
            {flight_reservations?.seat_preference?.replace(/_/g, " ") || 'No Data'}
          </b>
        </div>
        <Table
          rowKey="id"
          columns={flight_reservations?.mode === 'round_trip' ? round_trip_columns : one_way_columns}
          dataSource={
            flight_reservations?.trips?.length
              ? flight_reservations.trips : []}
          className="settingsTable tripsTable"
          pagination={false}
        />
        <div className='p1'>
          Time Preferences: &nbsp;
          Departure Time: <b className='capitalize'>{flight_reservations?.time_preference?.replace(/_/g, " ") || 'No Data'}</b>  &nbsp;| &nbsp;
          Return Time: <b className='capitalize'>{flight_reservations?.return_time_preference?.replace(/_/g, " ") || 'No Data'}</b> &nbsp;| &nbsp;
          Description: <b className='capitalize'>{flight_reservations?.description || 'No Data'}</b>
        </div>
      </div>
    </>
  );
};

export default FlightData;